import { patchSangjoQuotationRequestAcceptNightCall } from "@/apis/sangjoQuotation";
import { useRouter } from "next/router";
import { useMutation } from "react-query";

/**
 * request-complete가 6초 뒤 야간 수신 동의를 저장하고 결과 페이지로 넘긴다.
 *
 * 목적지를 `/match/recommendation`(id 없음) 하나로 통일했다. 예전에는 응답의
 * `first_quotation`으로 상세 경로를 만들고, 그 값이 없으면 견적 목록으로 떨어뜨렸다.
 * 결과 페이지가 `/me`로 견적서를 직접 찾으므로 id도 폴백도 필요 없다.
 * 견적서가 아직 없으면 `/me`가 만들어 주기 때문에 실패했을 때도 같은 곳으로 보낸다.
 */
export const usePatchSangjoQuotationRequestAcceptNightCall = (
  id: string,
  acceptNightCall: boolean,
) => {
  const router = useRouter();

  return useMutation(() => patchSangjoQuotationRequestAcceptNightCall(id, acceptNightCall), {
    onSuccess: () => router.replace("/match/recommendation/"),
    onError: () => router.replace("/match/recommendation/"),
  });
};
